/* ============================================================
   Accessibility helpers — Aplicaciones globales para WCAG
   ============================================================
   1) Marca iconos decorativos dentro de elementos accesibles
      (a/button con aria-label o texto propio) como aria-hidden.
      Evita doble lectura por el screen reader.
   2) Skip link funcional como fallback (Accessibe puede tener uno roto).
   ============================================================ */

(function () {
  'use strict';

  function hideDecorativeIconsInside(scope) {
    var root = scope || document;
    // Elementos interactivos que ya tienen nombre accesible (aria-label o texto)
    var interactiveEls = root.querySelectorAll('a[aria-label], button[aria-label], [role="button"][aria-label], a, button, [role="button"]');

    interactiveEls.forEach(function (el) {
      // Saltar elementos que NO tienen nombre accesible suficiente
      var hasAriaLabel = el.hasAttribute('aria-label') && el.getAttribute('aria-label').trim().length > 0;
      var textContent = (el.textContent || '').trim();
      if (!hasAriaLabel && textContent.length === 0) return;

      // Marcar iconos hijos como aria-hidden si no lo están
      var icons = el.querySelectorAll('iconify-icon:not([aria-hidden]), svg:not([aria-hidden]), .iconify:not([aria-hidden]), i.fa:not([aria-hidden]), i.fas:not([aria-hidden]), i.fab:not([aria-hidden]), i.far:not([aria-hidden]), i.fa-regular:not([aria-hidden]), i.fa-solid:not([aria-hidden]), i.fa-brands:not([aria-hidden])');
      icons.forEach(function (icon) {
        icon.setAttribute('aria-hidden', 'true');
        // i.fa de fontawesome también necesita focusable=false para evitar Tab
        if (icon.tagName === 'I') icon.setAttribute('focusable', 'false');
        if (icon.tagName === 'SVG' || icon.tagName === 'svg') icon.setAttribute('focusable', 'false');
      });
    });
  }

  // Reportar elementos focuseables sin nombre accesible (solo en consola, no toca el DOM)
  function reportUnlabeledInteractives() {
    var elements = document.querySelectorAll('a, button, [role="button"]');
    var unlabeled = [];
    elements.forEach(function (el) {
      var hasLabel = el.hasAttribute('aria-label') && el.getAttribute('aria-label').trim();
      var hasLabelledBy = el.hasAttribute('aria-labelledby');
      var text = (el.textContent || '').trim();
      var hasTitle = el.hasAttribute('title') && el.getAttribute('title').trim();
      // Si tiene imagen con alt, también vale
      var img = el.querySelector('img[alt]:not([alt=""])');
      if (!hasLabel && !hasLabelledBy && !text && !hasTitle && !img) {
        // Solo si es visible y NO es decorativo (aria-hidden=true)
        if (el.getAttribute('aria-hidden') === 'true') return;
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden') return;
        unlabeled.push(el);
      }
    });
    if (unlabeled.length > 0 && window.console && console.warn) {
      console.warn('[A11Y] ' + unlabeled.length + ' interactive elements without accessible name:', unlabeled);
    }
  }

  // Universal keyboard handler: cualquier [role="button"][tabindex="0"] que NO sea ya un <button> nativo
  // debe activar el click con Enter/Espacio (lo que el navegador hace gratis con <button>).
  function bindRoleButtonKeyboard() {
    document.addEventListener('keydown', function (e) {
      var t = e.target;
      if (!t || t.tagName === 'BUTTON' || t.tagName === 'A') return;
      if (t.getAttribute && t.getAttribute('role') !== 'button') return;
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        // Si está dentro de un select/textarea/input, no interferir
        if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') return;
        e.preventDefault();
        t.click();
      }
    });
  }

  // Añadir title a iframes externos (Shop Pay, YouTube embeds, etc.) que no lo traen.
  // WCAG 4.1.2 - "Frames must have accessible name"
  function addTitleToIframes() {
    document.querySelectorAll('iframe:not([title]), iframe[title=""]').forEach(function (iframe) {
      var id = iframe.id || '';
      var src = iframe.src || '';
      var title = 'Embedded content';
      if (id === 'PBarNextFrame' || src.indexOf('shop-pay') !== -1 || src.indexOf('shopify') !== -1) {
        title = 'Shop Pay installments offer';
      } else if (src.indexOf('youtube') !== -1 || src.indexOf('youtu.be') !== -1) {
        title = 'Embedded video';
      } else if (src.indexOf('vimeo') !== -1) {
        title = 'Embedded video';
      } else if (src.indexOf('google.com/maps') !== -1 || src.indexOf('maps.googleapis') !== -1) {
        title = 'Map';
      } else if (src.indexOf('tidio') !== -1) {
        title = 'Chat widget';
      }
      iframe.setAttribute('title', title);
    });
  }

  function run() {
    hideDecorativeIconsInside(document);
    addTitleToIframes();
    reportUnlabeledInteractives();
  }

  bindRoleButtonKeyboard();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-aplicar cuando se añade contenido dinámico (modales, fetched HTML, etc.)
  var observer = new MutationObserver(function (mutations) {
    var hasNewNodes = mutations.some(function (m) {
      return m.addedNodes && m.addedNodes.length > 0;
    });
    if (hasNewNodes) {
      // Debounce para no spamear
      clearTimeout(window._a11yIconHideTimer);
      window._a11yIconHideTimer = setTimeout(run, 200);
    }
  });
  observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
